import React from "react";
import { SiteHeader } from "../components/SiteHeader";
import { MobileCtaBar } from "../components/MobileCtaBar";
import { Hero } from "../components/sections/Hero";
import { Origin } from "../components/sections/Origin";
import { Journey } from "../components/sections/Journey";
import { Results } from "../components/sections/Results";
import { Transformation } from "../components/sections/Transformation";
import { SystemSection } from "../components/sections/SystemSection";
import { WhyItExists } from "../components/sections/WhyItExists";
import { Mentorship } from "../components/sections/Mentorship";
import { Outcomes } from "../components/sections/Outcomes";
import { Includes } from "../components/sections/Includes";
import { Freedom } from "../components/sections/Freedom";
import { Closing } from "../components/sections/Closing";
export function Landing() {
  return <div id="top" className="min-h-screen w-full bg-ink text-paper" data-id="element-250" data-mp="m7bx1z9gxacr">
      <SiteHeader data-id="element-251" data-mp="m5h9ed6tb44z" />
      <main data-id="element-252" data-mp="2a0i2180ic4m">
        <Hero data-id="element-253" data-mp="2ajtr072k4a7" />
        <Origin data-id="element-254" data-mp="2b3aweowaon6" />
        <Journey data-id="element-255" data-mp="2blgi1xg6f7r" />
        <Results data-id="element-256" data-mp="27xleycctkqx" />
        <Transformation data-id="element-257" data-mp="3tgbfzohq6wrq" />
        <WhyItExists data-id="element-258" data-mp="3tftmv0qd0yo1" />
        <SystemSection data-id="element-259" data-mp="3tfjvb8po2jg8" />
        <Mentorship data-id="element-260" data-mp="3tf0czqw3tt1o" />
        <Outcomes data-id="element-261" data-mp="3peq7sgg4z6nv" />
        <Includes data-id="element-262" data-mp="3pe826t7l3g3a" />
        <Freedom data-id="element-263" data-mp="3pfrkepcsw17p" />
        <Closing data-id="element-264" data-mp="3pf9q3y9p7x2f" />
      </main>
      <MobileCtaBar data-id="element-265" data-mp="3pgkspureqyry" />
      <footer className="border-t border-line px-6 pb-28 pt-8 text-center text-sm text-mute md:py-8" data-id="element-266" data-mp="3kfwt4kp459m4">
        © {new Date().getFullYear()} CLARIFY · Tu libertad con productos digitales
      </footer>
    </div>;
}